<template>
  <div class="page">
    <div class="ctrl">
      <a-radio-group v-model="order_by" @change="sort">
        <a-radio :value="1">按拍品</a-radio>
        <a-radio :value="2">按用户</a-radio>
      </a-radio-group>
    </div>
    <a-table
      class="sec"
      size="small"
      :rowKey="(record) => record.id"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <template slot="headimgurl" slot-scope="text, record">
        <a-button
          style="margin-right: 10px"
          size="small"
          icon="mail"
          @click="sendMsg(record.who, record.nickname)"
        ></a-button>
        <img style="height: 32px" :src="record.headimgurl" alt="" />
      </template>
      <template slot="win" slot-scope="text, record">
        {{ record.index }} / {{ record.winner_q }}
      </template>
      <template slot="status" slot-scope="text, record">
        <a-tag v-if="record.status == 1" color="orange">未结算</a-tag>
        <a-tag v-if="record.status == 2" color="blue">生成订单</a-tag>
      </template>

      <template slot="bid" slot-scope="text, record">
        <router-link :to="'/tuanpai/goods/bidList?goods_id=' + record.id"
          >出价记录</router-link
        >
      </template>
    </a-table>

    <SendMsg :msg="msg" v-if="msg.show" @callback="cancelSend" />
  </div>
</template>

<style lang='scss' scoped>
</style>

<script>
import SendMsg from '../../../components/sendMsg.vue'
const columns = [
  {
    title: "#",
    dataIndex: "id",
  },
  {
    title: "拍品",
    dataIndex: "goods_name",
  },
  {
    title: "编号",
    dataIndex: "goods_sn",
  },
  {
    title: "昵称",
    dataIndex: "nickname",
  },
  {
    title: "头像",
    scopedSlots: {
      customRender: "headimgurl",
    },
  },
  {
    title: "出价",
    dataIndex: "price",
  },
  {
    title: "排序",
    scopedSlots: {
      customRender: "win",
    },
  },
  {
    title: "状态",
    scopedSlots: {
      customRender: "status",
    },
  },
];

export default {
  components: { SendMsg },
  data() {
    return {
      columns,
      auc_id: null,
      list: [],
      order_by: 1,
      msg: {
        show: false,
        who: '',
        nickname: '',
        content: ''
      }
    };
  },
  created() {
    this.auc_id = this.$route.query.auc_id;
    this.getList();
  },
  methods: {
    sendMsg (who, nickname) {
      this.msg = {
        show: true,
        who,
        nickname,
        content: ''
      }
    },

    cancelSend () {
      this.msg = {
        show: false,
        who: '',
        nickname: ''
      }
    },
    async getList() {
      const r = await this.$axios.get("/tuanpai/getWinnerList", {
        params: {
          auc_id: this.auc_id,
        },
      });

      if (r.status != 1) return;

      this.list = r.list;
      this.sort();
    },
    sort() {
      if (this.order_by == 1) {
        this.list.sort((a, b) => {
          return a.goods_id - b.goods_id;
        });
      } else {
        this.list.sort((a, b) => {
          let r = 1
          if(a.who > b.who) r = -1;
          return r
        });
      }
    },
  },
};
</script>